<template>
<div>
  <h2>evo ga</h2>
</div>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {

    };
  },
};
</script>

<style scoped>

</style>
